export const WHO_AM_I_URL = '/api/who-am-i/';

export const URL_COMPANY_INFO = '/api/account/company/';
export const URL_LIABLE_PARTNER = '/api/account/responsible/';
export const URL_LOGISTIC_ADDRESS = '/api/account/logistic-address/';
export const URL_REFRESH_WEBAPP_TOKEN = '/api/account/refresh-session/';

export const BANK_ACCOUNT_URL = '/api/account/bank-account/';

export const BFF_BASE_URL = '/bff/acquisition/v1';
export const GET_VIACEP_BY_CEP = `${BFF_BASE_URL}/onboarding/hub-coverage`;
export const BFF_BASE_URL_V2 = '/bff/acquisition/v2';
export const URL_LEAD_INFO = (leadId) => `${BFF_BASE_URL}/leadsV2/${leadId}`;
export const URL_FULL_LEAD = (email) => {
  return `${BFF_BASE_URL}/leadsV2/full-lead/${email ? `&email=${email}` : ''}`;
};
export const URL_SUBSCRIPTION_PLAN_CHOICE = `${BFF_BASE_URL}/subscriptions/plans-choice`;
export const URL_SUBSCRIPTION_PLAN_V2_CHOICE = `${BFF_BASE_URL}/subscriptions/v2/plans-choice/`;
export const URL_SUBSCRIPTION_PLAN_OPTIONS = `${BFF_BASE_URL}/subscriptions/plan-options`;
export const FIRST_STEPS_URL = `${BFF_BASE_URL}/onboarding/first-steps`;
export const SELLER_TAGS_URL = `${BFF_BASE_URL}/onboarding/seller-tags`;
export const PERSONAL_INFORMATION_API_URL = `${BFF_BASE_URL}/onboarding/personal-information/`;
export const UNLEASH_EXPERIMENT_URL = (tagName) => `${BFF_BASE_URL}/unleash/tag/${tagName}`;
